module.exports = "<p>\n  bra-checkbox works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-checkbox/bra-checkbox.component.html
// module id = ../../../../../src/app/componentes/bra-checkbox/bra-checkbox.component.html
// module chunks = main